import { jsxs, jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { textStyles } from "./textStyles.js";
import { token } from "./token.js";
import { useGroupParent } from "./useGroupContext.js";
function Label({
  children,
  secondaryText,
  htmlFor,
  id,
  ...props
}) {
  useGroupParent("Label");
  return /* @__PURE__ */ jsxs(LabelStyled, {
    htmlFor,
    id,
    ...props,
    children: [children, secondaryText ? /* @__PURE__ */ jsxs(SecondaryText, {
      children: [/* @__PURE__ */ jsx(Space, {
        children: " "
      }), secondaryText]
    }) : null]
  });
}
const LabelStyled = styled.label.withConfig({
  displayName: "LabelStyled",
  componentId: "sc-17wblts-0"
})(["", " display:block;margin:0 0 ", ";padding:0;border:none;color:", ";"], textStyles.uiTextM, token.spacing3, token.colorText);
const SecondaryText = styled.span.withConfig({
  displayName: "SecondaryText",
  componentId: "sc-17wblts-1"
})(["color:", ";"], token.colorTextMuted);
const Space = styled.span.withConfig({
  displayName: "Space",
  componentId: "sc-17wblts-2"
})(["display:inline-block;width:", ";"], token.spacing3);
export {
  Label
};
//# sourceMappingURL=Label.js.map
